import { AuthError } from './auth-error';

export class InvalidCredentialsError extends AuthError {
  
}